import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core'
import styled from 'styled-components'
import { formatMessage } from '../constants/strings/intl/intlHooks'
import { atlTheme } from '../atlTheme'
import { defaultMessageCancelButton, defaultMessageConfirmButton } from '../constants/strings/defaultMessageModalWeb'

const DialogTitleWeb = styled(DialogTitle)`
  color: ${atlTheme.ColorBrand2High} !important;
  font-weight: 500;
`
const ButtonWeb = styled(Button)`
  color: ${atlTheme.ColorBrand2High} !important;
  font-weight: 500;
`
interface ModalWebProps {
  open: boolean
  onClose: () => void
  title: string
  description: string
  onConfirmButton: () => void
  onCancelButton: () => void
  messageConfirmButton?: string
  messageCancelButton?: string
}

export const ModalWeb: React.FC<ModalWebProps> = ({
  open,
  onClose,
  title,
  description,
  onConfirmButton,
  onCancelButton,
  messageConfirmButton,
  messageCancelButton,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitleWeb>{formatMessage(title)}</DialogTitleWeb>
      <DialogContent>
        <DialogContentText>{description && formatMessage(description) || ''}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <ButtonWeb onClick={onCancelButton}>
          {formatMessage(messageCancelButton || defaultMessageCancelButton)}
        </ButtonWeb>
        <ButtonWeb onClick={onConfirmButton}>
          {formatMessage(messageConfirmButton || defaultMessageConfirmButton)}
        </ButtonWeb>
      </DialogActions>
    </Dialog>
  )
}
